import React from 'react';
import PropTypes from 'prop-types';
import ContactFlow from './ContactFlow.jsx';
import useNeuroState, {
  appointmentLocationSearchUpdated,
  appointmentLocationSelected,
  appointmentTimeSlotSelected,
  bookAppointment,
  contactLeadUpdate,
  getAvailableTimeSlots,
  getLocations,
  useDispatch,
} from '../../state/index';

const ConnectedContactFlow = (props) => {
  const { ...rest } = props;
  const dispatch = useDispatch();
  const { contactMe = {}, answers } = useNeuroState();

  const defaultZipCode = answers?.postalCode?.value?.toString();

  const oldReduxProps = {
    availableLocations: contactMe.availableLocations,
    availableTimeSlots: contactMe.availableTimeSlots,
    contactLead: contactMe.contactLead,
    isProcessing: contactMe.isProcessing,
    locationSearchForm: contactMe.locationSearchForm || {
      zipCode: defaultZipCode,
    },
    selectedLocation: contactMe.selectedLocation,
    selectedTime: contactMe.selectedTime,
  };

  const oldReduxActions = {
    onContactFormSubmit: (contactLead, fieldsForAnswerService) => {
      dispatch(contactLeadUpdate({ contactLead, fieldsForAnswerService }));
    },
    onLocationSearchChange: (search) => {
      dispatch(appointmentLocationSearchUpdated(search));
    },
    setLocation: (location) => {
      dispatch(appointmentLocationSelected(location));
    },
    getLocations: (coordinates) => {
      dispatch(getLocations(coordinates));
    },
    getTimeSlots: (request) => {
      dispatch(getAvailableTimeSlots(request));
    },
    setTimeSlot: (timeSlot) => {
      dispatch(appointmentTimeSlotSelected(timeSlot));
    },
    bookAppointment: (appointment, getNextScreen) => {
      dispatch(bookAppointment(appointment, getNextScreen));
    },
  };

  return <ContactFlow {...rest} {...oldReduxProps} {...oldReduxActions} />;
};
ConnectedContactFlow.propTypes = {
  hasBeenClicked: PropTypes.bool,
};

export default ConnectedContactFlow;
